// extracted by mini-css-extract-plugin
export default {"cls1":"FilterTextField-Text_cls1__9HWH0","cls2":"FilterTextField-Text_cls2__DJAl1 FilterTextField-Text_cls1__9HWH0"};